import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const getBonsData = async () => {
  const response = await axios.get(`${API_URL}/bon-livraison`);
  return response?.data?.data ?? [];
};

export const createBonLivraison = async (data) => {
  const response = await axios.post(`${API_URL}/bon-livraison`, data);
  return response.data;
};

export const deleteBonLivraison = async (id) => {
  const response = await axios.delete(`${API_URL}/bon-livraison/${id}`);
  return response.data;
};

export const updateBonLivraison = async (id, data) => {
  const response = await axios.put(`${API_URL}/bon-livraison/${id}`, data);
  return response.data;
};

export const getBonLivraison = async (id) => {
  const response = await axios.get(`${API_URL}/bon-livraison/${id}`);
  console.log(response.data.data);
  
  return response.data.data;
}